/**
 * To build this file, run `npx rollup -c rollup-transitional.config.js` in the
 * root directory. This will output test/transitional/cps.js. Then, run
 * `build -t` to copy the build products into the build folder. Run
 * `python3 -m http.server 8000` in the build folder to view the results in
 * your browser by visiting http://localhost:8000/transitional.html.
 *
 * A slow but workable one-liner: `find test/transitional/ -type f | entr -s "npx rollup -c rollup-transitional.config.js && ./build.sh -t"`
 */
export * as domain from '../../domain';
export * as IIID from '../../IIID';

// Note that here we're exporting the AssetManager instance, which is the
// default export from the assets module.
import _assets from '../../assets';
export const assets = _assets;

import * as utils_classic from '../../utils';
import animateOpen from '../../utils/animateOpen';
import createTechDrawingLabel from '../../utils/createTechDrawingLabel';
import directionalPosition from '../../utils/directionalPosition';
import gammaCorrect from '../../utils/gammaCorrect';
import lookAtWall from '../../utils/lookAtWall';
import makeKitchenLights from '../../utils/makeKitchenLights';
import makeMainLights from '../../utils/makeMainLights';
import optimizeDirectionalShadow from '../../utils/optimizeDirectionalShadow';
import toTechnicalDocument from '../../utils/toTechnicalDocument';
import { rouler } from '../../utils/rouler';
export const utils = {
    ...utils_classic,
    animateOpen,
    createTechDrawingLabel,
    directionalPosition,
    gammaCorrect,
    lookAtWall,
    makeKitchenLights,
    makeMainLights,
    optimizeDirectionalShadow,
    rouler,
    toTechnicalDocument,
}

import * as THREE_CLASSIC from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter';
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils';
export const THREE = {
    ... THREE_CLASSIC,
    BufferGeometryUtils,
    GLTFExporter,
    GLTFLoader,
    OBJExporter,
    OBJLoader,
    FontLoader,
    TextGeometry,
};

import ClosetUnitView from '../../views/ClosetUnitView';
import CubbyView from '../../views/CubbyView';
import DividerView from '../../views/DividerView';
import DoorView from '../../views/DoorView';
import DrawerView from '../../views/DrawerView';
import GenericAssetView from '../../views/GenericAssetView';
import HandleView from '../../views/HandleView';
import HookRackView from '../../views/HookRackView';
import LightsView from '../../views/LightsView';
import MurphybedView from '../../views/MurphybedView';
import ParametricPartView from '../../views/ParametricPartView';
import RoomView from '../../views/RoomView';
import SectionView from '../../views/SectionView';
import StackLayoutHepler from '../../views/StackLayoutHepler';
import VerticalPanelView from '../../views/VerticalPanelView';
import WallView from '../../views/WallView';

export const views = {
    ClosetUnitView,
    CubbyView,
    DividerView,
    DoorView,
    DrawerView,
    GenericAssetView,
    HandleView,
    HookRackView,
    LightsView,
    MurphybedView,
    ParametricPartView,
    RoomView,
    SectionView,
    StackLayoutHepler,
    VerticalPanelView,
    WallView,
};

export * as prefill from '../../controllers/prefill';

import '../../dev';
import * as dm from '../../domain';
import Application from '../../Application';
import DefaultsManager from '../../DefaultsManager';
import OrbitTool from '../../tools/OrbitTool';
import { DummyRenderPipeline, PerspectiveRenderPipeline } from '../../RenderPipeline';
import materialFactory from '../../MaterialFactory';
import parametricCache from '../../ParametricCache';

export const mfac = materialFactory;
export const pc = parametricCache;

export class TransitionalApp extends Application {

    constructor(defaults: dm.Defaults) {
        super();
        this.defaults = new DefaultsManager(defaults);
        this.pipeline = new DummyRenderPipeline();
    }

    async start(): Promise<void> {
    }

    async refresh(): Promise<void> {
    }

}

export class SimpleApp extends Application {
    navtool: OrbitTool;

    constructor(defaults: dm.Defaults) {
        super();
        this.defaults = new DefaultsManager(defaults);
        this.pipeline = new PerspectiveRenderPipeline();
        this.navtool = new OrbitTool(this);

        this.navtool.controls.enablePan = true;
        this.navtool.controls.screenSpacePanning = true;
        this.navtool.controls.minAzimuthAngle = -Infinity;
        this.navtool.controls.maxAzimuthAngle = Infinity;
        this.navtool.controls.minDistance = 0;
        this.navtool.controls.maxDistance = Infinity;
    }
    async start(): Promise<void> {
        this.pipeline.start();
        this.navtool.enable();
    }
    refresh(): Promise<void> {
        throw new Error('Method not implemented.');
    }
}
